module.exports = __webpack_public_path__ + "static/img/superhero_01.bd64d40.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/desktop@1x/pic/superhero_01.png
// module id = Znoa
// module chunks = 0